import { ModalBody, ModalHeader } from 'reactstrap';
import styled from 'styled-components';

import Modal from './basics/Modal';
import { SHORTCUTS } from '../constants/shortcuts';
import Shortcut from './basics/Shortcut';
import { formatHotkeyExpression } from '../utils/shortcuts';
import { MODALS, useGlobalModal } from '../contexts/GlobalModalsContext';
import { layerTypesWithShortcuts } from '../constants/map';

const InfoDiv = styled.div`
  margin-bottom: 4px;

  kbd {
    background-color: var(--gray);
  }
  span {
    vertical-align: middle;
  }
`;

const ShortcutInfo = ({ id }) => {
  const { key, description } = SHORTCUTS[id];

  return (
    <InfoDiv>
      <kbd>{formatHotkeyExpression(key)}</kbd>
      <span className="ml-2">{description}</span>
    </InfoDiv>
  );
};

const Section = styled.ul`
  margin-bottom: 16px;

  h4 {
    font-weight: bold;
    margin-bottom: 4px;
  }
`;

const ShortcutsModal = () => {
  const { isOpen, setIsOpen } = useGlobalModal(MODALS.SHORTCUTS);

  return (
    <>
      <Modal size="lg" centered isOpen={isOpen} toggle={() => setIsOpen(false)}>
        <ModalHeader tag="div" className="p-3">
          <h2 className="m-0 font-weight-bold">Shortcuts</h2>
        </ModalHeader>

        <ModalBody className="font-large">
          <div className="d-flex w-100 justify-content-between">
            <div className="p-2 w-50">
              <Section>
                <h4>Fields page</h4>
                <ShortcutInfo id="SHOW_HIDE_GROUPS" />
                <ShortcutInfo id="SHOW_HIDE_LAYERS" />
                <ShortcutInfo id="SHOW_HIDE_SECTIONS" />
                <ShortcutInfo id="TOGGLE_RIGHT_MENU_TABS" />
                <ShortcutInfo id="TOGGLE_MAP_FULLSCREEN" />
              </Section>

              <Section>
                <h4>Section/Layer editing</h4>
                <ShortcutInfo id="DRAW" />
                <ShortcutInfo id="EDIT" />
                <ShortcutInfo id="ROTATE" />
                <ShortcutInfo id="OFFSET" />
              </Section>

              <Section>
                <h4>Section creation</h4>
                <ShortcutInfo id="NEW_GRID" />
                <ShortcutInfo id="NEW_LINE" />
                <ShortcutInfo id="NEW_KEYLINE" />
              </Section>

              <Section>
                <h4>Measurement</h4>
                <ShortcutInfo id="START_MEASUREMENT" />
                <ShortcutInfo id="MEASURE_DISTANCE" />
                <ShortcutInfo id="MEASURE_AREA" />
              </Section>
            </div>

            <div className="p-2 w-50">
              <Section>
                <h4>Layer selection/creation</h4>
                {layerTypesWithShortcuts.map((layerType) => (
                  <ShortcutInfo key={layerType} id={layerType} />
                ))}
              </Section>

              <Section>
                <h4>Custom layer draw modes</h4>
                <ShortcutInfo id="CUSTOM_LAYER_DRAW_POINT" />
                <ShortcutInfo id="CUSTOM_LAYER_DRAW_LINE" />
                <ShortcutInfo id="CUSTOM_LAYER_DRAW_POLYGON" />
              </Section>

              <Section>
                <h4>Economics pages</h4>
                <ShortcutInfo id="TOGGLE_CHART" />
                <ShortcutInfo id="TOGGLE_DESIGN_PANEL" />
              </Section>

              <Section>
                <h4>Other</h4>
                <ShortcutInfo id="CLOSE" />
                <ShortcutInfo id="SHOW_SHORTCUTS" />
              </Section>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Shortcut
        shortcut={SHORTCUTS.SHOW_SHORTCUTS.key}
        handler={() => setIsOpen(true)}
      />
    </>
  );
};

export default ShortcutsModal;
